<mbs-card class="card-form">
  <mbs-card-group>
    <h5 class="m-0 mb-1">{{ 'storages:buckets' | i18next }}</h5>
    <div>{{ 'storages:addStorageAccountWizard.advancedSettingsStep.allBucketsUsed' | i18next }}</div>
  </mbs-card-group>

  <mbs-card-group>
    <div class="d-flex mb-1">
      <h5 class="m-0">
        {{ 'storages:addStorageAccountWizard.advancedSettingsStep.useSpecificBuckets' | i18next }}
        @if (specificBucketsControl.value.length) {
          <span>({{ specificBucketsControl.value?.length }})</span>
        }
      </h5>

      <div class="ml-auto">
        <mbs-switcher [formControl]="useSpecificBucketsControl"></mbs-switcher>
      </div>
    </div>

    <div>
      @if (preparedBucketsValue().length) {
        <div class="mb-1">
          <mbs-text-ellipsis>{{ preparedBucketsValue() }}</mbs-text-ellipsis>
        </div>
      }

      <mbs-button
        [disabled]="!useSpecificBucketsControl?.value"
        [isCtrl]="true"
        [loading]="loading()"
        (click)="onBucketsButtonClick()">
        {{
          (specificBucketsControl.value?.length
            ? 'storages:addStorageAccountWizard.advancedSettingsStep.editBuckets'
            : 'storages:addStorageAccountWizard.advancedSettingsStep.selectBuckets'
          ) | i18next
        }}
      </mbs-button>
    </div>
  </mbs-card-group>
</mbs-card>

<ng-template #specifyBucketsModalContent>
  <mbs-tags-input
    [formControl]="specificBucketsControl"
    [fromSuggestionsOnly]="true"
    [label]="'storages:buckets' | i18next"
    [suggestions]="bucketNames">
  </mbs-tags-input>
</ng-template>
